export function  initOption(dataList,name,code) {
  var legend = []
  var data = []
  if(dataList){
    dataList.forEach(item =>{
      legend.push(item[name])
      data.push(item[code])
    })
  }
  var option = {
    xAxis: {
      data: legend,
      axisLabel:{
        interval: 0
      }
    },
    yAxis: {
      show: false
    },
    series: [
      {
        name: '',
        type: 'bar',
        barWidth: 10,
        label: {
          show:true,
          position: 'top', // 设置标签在柱形图上方
          color: '#000000' // 设置标签颜色
        },
        data: data
      }
    ]
  }
  return option
}



// WEBPACK FOOTER //
// ./src/components/chart/ChartJS.js